module.exports = __webpack_public_path__ + "img/OPTIMA-COIL-SYSTEM-DEF-584x584.28112fff.webp";